import React from 'react';
import {
    StyledPlaceHolderItem,
    StyledPlaceHolder,
    StyledRow1,
    StyledRow2,
    StyledRow3,
    StyledRow4,
} from './PlaceHolder.styles';

export enum PlaceholderLayout {
    DEFAULT = 'DEFAULT',
    COLUMN = 'COLUMN',
    HEADER_TEXT = 'HEADER_TEXT',
    HERO = 'HERO',
    LETTER_GRID = 'LETTER_GRID',
    CHANNELS = 'CHANNELS',
    SHOWCASE = 'SHOWCASE',
    PORTRAIT = 'PORTRAIT',
    GRID = 'GRID',
}

type Props = {
    nrOfItems?: number;
    layout?: PlaceholderLayout;
};

export const PlaceHolder = ({ nrOfItems = 12, layout = PlaceholderLayout.DEFAULT }: Props): JSX.Element => (
    <StyledPlaceHolder layout={layout}>
        {[...new Array(nrOfItems)].map((item, i) => (
            <StyledPlaceHolderItem key={`placeholder-${i}`}>
                <StyledRow1 layout={layout} />
                <StyledRow2 />
                <StyledRow3 />
                <StyledRow4 />
            </StyledPlaceHolderItem>
        ))}
    </StyledPlaceHolder>
);

export default PlaceHolder;
